module.exports = __webpack_public_path__ + "img/2_A.0d31917a.webp";